import { selectAppById } from "@app/deploy";
import { useSelector } from "@app/react";
import { appActivityUrl } from "@app/routes";
import { Navigate, useParams } from "react-router-dom";
import { AppServicesByApp, DetailPageSections } from "../shared";

export function AppDetailServicesPage() {
  const { id = "" } = useParams();
  const app = useSelector((s) => selectAppById(s, { id }));

  if (app.deletedAt) {
    return <Navigate to={appActivityUrl(id)} replace />;
  }

  return (
    <DetailPageSections>
      <AppServicesByApp appId={app.id} />
    </DetailPageSections>
  );
}
